import * as React from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  Col,
  Grid,
  ListGroup,
  Row
} from "react-bootstrap";
import {
  GFInitialState,
  GFLesson,
  GFQuizItem,
  GFUser,
  GFWritingAssignment,
  Option
} from "../../models/models";
import { RouteComponentProps, browserHistory } from "react-router";
import { filter, find, isEmpty, map } from "lodash";
import {
  initialCustomLesson,
  initialLesson
} from "../../reducers/initialState";
import { selectClassOptions } from '../../reducers/classReducer';
import { LinkContainer } from "react-router-bootstrap";
import { QuizWAListItem } from "./QuizWAListItem";
import VerificationAlert from "../common/VerificationAlert";
import { connect } from "react-redux";
import constants from "../../constants";
import { postQuizToGoogleClassroom, postWAToGoogleClassroom } from "../../actions/googleActions";
import { getAllWAByLessonID } from "../../actions/waActions";
import { getCustomLessons } from "../../actions/customLessonActions";
import { getLessonsByCourseID } from "../../actions/lessonActions";
import { getQuizzesByLessonID } from "../../actions/quizActions";
import { sortBy } from "lodash";
import { toastr } from "react-redux-toastr";
import { selectIsStudent, selectIsTeacher, selectHasGoogleClasses } from "../../reducers/userReducer";
import { quizTypeEnum, socialServiceEnum } from "../../enums";
import resolveDomain from '../../resolve-domain';
import MainMenu from '../menu/MainMenu';
import LessonResources from './LessonResources';

const graham = require("../../images/graham.gif");

const mixpanel = require("mixpanel-browser");

interface RouterParams {
  courseID: string;
  lessonID: string;
}

interface Props extends RouteComponentProps<RouterParams, {}> {
  user: GFUser;
  lesson: GFLesson;
  quizzes: { [key: string]: GFQuizItem };
  getLessonsByCourseID: typeof getLessonsByCourseID;
  getQuizzesByLessonID: typeof getQuizzesByLessonID;
  getAllWAByLessonID: typeof getAllWAByLessonID;
  writingAssignments: { [key: string]: GFWritingAssignment };
  loading: boolean;
  lessonQuizzes: GFQuizItem[]; // the quizzes for this lesson
  getCustomLessons: typeof getCustomLessons;
  postEvalEnabled: boolean;
  isStudent: boolean;
  isTeacher: boolean;
  postQuizToGoogleClassroom: typeof postQuizToGoogleClassroom;
  postWAToGoogleClassroom: typeof postWAToGoogleClassroom;
  classOptions: Option[];
  hasGoogleClasses: boolean;
}

class Lesson extends React.Component<Props> {
  componentWillMount() {
    const { lessonID, courseID } = this.props.params;
    if (!lessonID || !courseID) {
      // no lesson id and no coursID is not allowed
      browserHistory.push(`/courses`);
      return;
    }
    if (!this.props.lesson.id.length) {
      this.props.getLessonsByCourseID(courseID);
    }
    if (this.props.isStudent && this.props.user.classes.length) {
      // verify that the student only has 1 class.  If not then the customLessons will not work properly
      if (this.props.user.classes.length > 1) {
        console.error("student has too many classes", this.props.user.classes);
      }
      this.props.getCustomLessons(this.props.user.classes[0].id);
    }
    // after a bit get the most up to date quiz questions and the status
    this.props.getQuizzesByLessonID(lessonID);

    this.props.getAllWAByLessonID(lessonID);

    mixpanel.track("Lesson clicked", {
      lesson: lessonID,
      name: this.props.lesson.name
    });
    window.scrollTo(0, 0);
  }

  /*
  * Go to quiz.
  * Quiz will check if this is a post-eval and if it is enabled
  */
  startQuiz = (gfQuiz: GFQuizItem) => {
    // set the current active quiz item
    this.goToQuiz(gfQuiz);
  };
  goToQuiz = (gfQuiz: GFQuizItem) => {
    mixpanel.track("Practice Exercise started", {
      quiz: gfQuiz.id,
      name: gfQuiz.name
    });
    const path = `/quiz/${this.props.params.courseID}/${
      this.props.params.lessonID
    }/${gfQuiz.id}`;
    browserHistory.push(path);
  };
  goToQuizAnswers = (gfQuiz: GFQuizItem) => {
    mixpanel.track("Print View selected", {
      quiz: gfQuiz.id,
      name: gfQuiz.name
    });
    const path = `/quizAnswers/${this.props.params.courseID}/${
      this.props.params.lessonID
    }/${gfQuiz.id}`;
    browserHistory.push(path);
  };

  /*
  * Start a Writing assignment
  */
  startWA = (wa: GFWritingAssignment) => {
    mixpanel.track("Writing Assignment started", {
      writingAssignmentID: wa.id,
      writingAssignmentName: wa.name
    });
    const path = `/writingassignment/${this.props.params.courseID}/${
      this.props.params.lessonID
    }/${wa.id}`;
    window.scrollTo(0, 0);
    browserHistory.push(path);
  };

  render() {
    let courseName;
    if (
      this.props.user.id &&
      this.props.lesson.id &&
      this.props.lesson.courseLessons &&
      this.props.lesson.courseLessons[0].course
    ) {
      courseName = this.props.lesson.courseLessons[0].course.name;
    }

    const contClasses = this.props.isStudent
      ? "main-content content-without-sidebar lesson animated fadeIn"
      : "main-content content-with-sidebar lesson animated fadeIn";

    const preTest = this.props.lessonQuizzes.find(q => q.type === quizTypeEnum.diagnostic);
    const preTestsOptional = this.props.user.classes[0]?.preTestsOptional || false;
    const isResourcesLocked = this.props.isStudent && ! (preTest?.isComplete || preTestsOptional);

    const isResourcesLockedCallback = () => {
      toastr.warning('', 'You must complete the pre-test before accessing any instructional or assessment content.');
    }

    return (
      <Grid className="content modal-container">
        {this.props.isTeacher && (
          <div className="sidemenu">
            <MainMenu/>
            <div className="logo text-center">
              <img alt="graham" src={graham} />
            </div>
          </div>
        )}
        <div className={contClasses}>
          <VerificationAlert user={this.props.user} isTeacher={this.props.isTeacher} />
          <Row className="sub-header">
            <Col md={10} xs={10} className="gf-breadcrumb lesson">
              <Breadcrumb>
                <LinkContainer
                  to={`/courseLessons/${this.props.params.courseID}`}
                >
                  <BreadcrumbItem>
                    <span>{courseName}</span>
                  </BreadcrumbItem>
                </LinkContainer>
                <BreadcrumbItem active={true}>
                  {this.props.lesson.name}
                </BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <LessonResources
            lesson={this.props.lesson}
            isResourcesLockedCallback={isResourcesLockedCallback}
            isResourcesLocked={isResourcesLocked}
            preTest={preTest}
            startQuiz={this.startQuiz}
            isStudent={this.props.isStudent}
          />
          {this.props.lessonQuizzes.length !== 0 && (
            <h1>Pre-Test, Practice Exercises, and Post-Evaluation</h1>
          )}
          <ListGroup className="lesson-list">
            {this.props.lessonQuizzes.map((gfQuiz, index) => {
              const isQuizLockedForPreTest = isResourcesLocked && gfQuiz.type !== quizTypeEnum.diagnostic;
              const isPostEval =
                gfQuiz.type === quizTypeEnum.postEval;
              const enabled =
                !isPostEval || (isPostEval && this.props.postEvalEnabled);
              const itemUrl = `${resolveDomain().host}/quiz/${this.props.params.courseID}/${
                this.props.params.lessonID
              }/${gfQuiz.id}`;
              return (
                <QuizWAListItem
                  key={gfQuiz.id}
                  onClick={() => {
                    if(!enabled && this.props.isStudent){
                      toastr.warning(
                        "",
                        "Your teacher must enable the Post-Evaluation before you can proceed.",
                        constants.toastrSuccess
                      );
                    } else if (this.props.user.paymentPlan === "trial" && isPostEval) {
                      toastr.warning("", "Post-Evaluations are not enabled on trial accounts.");
                    } else {
                      if (isQuizLockedForPreTest) {
                        return isResourcesLockedCallback();
                      }

                      this.startQuiz(gfQuiz);
                    }
                  }}
                  enabled={enabled}
                  item={gfQuiz}
                  type="quiz"
                  itemUrl={itemUrl}
                  onPrintView={this.goToQuizAnswers}
                  isTeacher={this.props.isTeacher}
                  isGoogleUser={this.props.user.hasOwnProperty('socialType') && this.props.user.socialType === socialServiceEnum.google && this.props.hasGoogleClasses}
                  lessonID={this.props.params.lessonID}
                  lesson={this.props.lesson}
                  postQuizToGoogleClassroom={this.props.postQuizToGoogleClassroom}
                  postWAToGoogleClassroom={this.props.postWAToGoogleClassroom}
                  classOptions={this.props.classOptions}
                  isTrial={this.props.user.paymentPlan === "trial"}
                  isQuizLockedForPreTest={isQuizLockedForPreTest}
                />
              );
            })}
          </ListGroup>
          {!isEmpty(this.props.writingAssignments) && (
            <h1>Writing Activities</h1>
          )}
          <ListGroup>
            {map(this.props.writingAssignments, (wa, index) => {
              const itemUrl = `${resolveDomain().host}/writingassignment/${this.props.params.courseID}/${
                this.props.params.lessonID
              }/${wa.id}`;
              return (
                <QuizWAListItem
                  key={wa.id}
                  onClick={(wa: GFWritingAssignment) => {
                    if (isResourcesLocked) {
                      return isResourcesLockedCallback();
                    }

                    this.startWA(wa);
                  }}
                  enabled={true}
                  item={wa}
                  type="writingassignment"
                  itemUrl={itemUrl}
                  onPrintView={this.goToQuizAnswers}
                  isTeacher={this.props.isTeacher}
                  isGoogleUser={this.props.user.hasOwnProperty('socialType') && this.props.user.socialType === socialServiceEnum.google && this.props.hasGoogleClasses}
                  lesson={this.props.lesson}
                  postQuizToGoogleClassroom={this.props.postQuizToGoogleClassroom}
                  postWAToGoogleClassroom={this.props.postWAToGoogleClassroom}
                  classOptions={this.props.classOptions}
                  isTrial={this.props.user.paymentPlan === "trial"}
                  isQuizLockedForPreTest={isResourcesLocked}
                />
              );
            })}
          </ListGroup>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  // if this is a student, user their classID, if a teacher then user the selected class
  const { user, selectedClassID } = state;
  const classOptions = selectClassOptions(state);
  const isStudent = selectIsStudent(state);
  const classID =
    isStudent && user.classes.length
      ? user.classes[0].id
      : selectedClassID;
  const lesson = state.lessons[ownProps.params.lessonID] || initialLesson;
  const lessonQuizzes =
    sortBy(
      filter(state.quizzes, {
        lessonID: ownProps.params.lessonID
      }),
      "type"
    ) || [];

  // find the customLesson for this lesson and class then check if the post-eval is enabled
  const customLesson =
    find(
      state.customLessons,
      customL =>
        customL.lessonID === ownProps.params.lessonID &&
        customL.classID === classID
    ) || initialCustomLesson;

  // post-evals are disabled for students unless a teacher has enabled them for the class
  // post-evals are enabled for Teachers who select "view all lessons" or if they have enabled them for the class they have selected
  let postEvalEnabled = false;
  if (selectedClassID.length === 0 && isStudent === false) {
    postEvalEnabled = true;
  } else {
    postEvalEnabled =
      customLesson && !customLesson.postEvalEnabled ? false : true;
  }

  return {
    user: state.user,
    lesson,
    lessonQuizzes,
    writingAssignments: state.writingAssignments,
    postEvalEnabled,
    loading: state.ajaxCallsInProgress > 0,
    isStudent,
    isTeacher: selectIsTeacher(state),
    classOptions,
    hasGoogleClasses: selectHasGoogleClasses(state),
  };
};

export default connect(
  mapStateToProps,
  {
    getLessonsByCourseID,
    getQuizzesByLessonID,
    getAllWAByLessonID,
    getCustomLessons,
    postQuizToGoogleClassroom,
    postWAToGoogleClassroom,
  }
)(Lesson);
